<template>
	<div>
		<img src="/img/end.png" />
		<p style="color: #EAEAEA;">{{text1}}</p>
		<p style="color: #666666;">{{text2}}</p>
	</div>
</template>

<script>
	export default {
		created() {
			let query = this.$route.query.text || '活动已结束,请联系您的客户经理了解详情!'
			this.text1 = query.split(',')[0] ? query.split(',')[0] : ''
			this.text2 = query.split(',')[1] ? query.split(',')[1] : ''
		},
		data(){
			return{
				text1:'',
				text2:''
			}
		}
	}
</script>

<style scoped>
	div{
		text-align: center;
	}
	img{
		margin: auto;
		margin-top: 40%;
	}
	p{
		margin-bottom: 20px;
		font-size: 16px;
	}
</style>